import { render } from "./PermisosAdministracion.vue?vue&type=template&id=3cc02b8e"
import script from "./PermisosAdministracion.vue?vue&type=script&lang=js"
export * from "./PermisosAdministracion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__